export const tableOption = {
  border: true,
  // index: true,
  // indexLabel: '序号',
  menu: false, // 操作列
  delBtn: false,
  stripe: true,
  menuAlign: 'center',
  align: 'left',
  refreshBtn: false,
  searchSpan: 15,
  // columnBtn:false,
  searchMenuSpan: 4,
  showClomnuBtn: false,
  searchSize: 'mini',
  // menu:false,
  addBtn: false,
  editBtn: true,
  viewBtn: false,
  reserveSelection: true,
  props: {
    label: 'label',
    value: 'value',
  },
  column: [
    {
      label: '轻任务订单号',
      prop: 'orderId',
      row: true,
      editDisplay: false,
      span: 24,
      width: 100,
    },
    {
      label: '语种',
      editDisplay: false,
      prop: 'slan',
      row: true,
    },
    {
      label: '流程环节',
      editDisplay: false,
      prop: 'orderFlowName',
      row: true,
      width: 100,
    },
    {
      label: '领域',
      editDisplay: false,
      prop: 'fieldName',
      row: true,
    },
    {
      label: '开始时间',
      editDisplay: false,
      prop: 'startTime',
      row: true,
    },
    {
      label: '要求完成时间',
      sortable: true,
      editDisplay: false,
      prop: 'limitTime',
      row: true,
      slot: true,
    },
    {
      label: '总句数 / 已完成句数 / 进行中包数 / 待领取包数 / 人数',
      width: 150,
      sortable: false,
      editDisplay: false,
      slot: true,
      prop: 'totalNum',
      row: true,
    },
    {
      label: '任务状态',
      width: 70,
      editDisplay: false,
      type: 'select',
      dicData: [],
      row: true,
      prop: 'projectStaus',
    },
    {
      label: '置顶时间/置底时间',
      width: 150,
      editDisplay: false,
      prop: 'sortTime',
      slot: true,
      row: true,
    },
    {
      label:
        '质控（ 总进度 / 已处理 / 审核中 / 未处理 / 待处理字数 / 全部字数）',
      width: 200,
      sortable: false,
      editDisplay: false,
      prop: 'qc',
      slot: true,
      row: true,
    },
    {
      label: 'PM',
      width: 70,
      editDisplay: false,
      prop: 'pmName',
      row: true,
      formslot: true,
    },
    {
      label: '客户名称',
      prop: 'custName',
      editDisplay: false,
      row: true,
      formslot: true,
    },
    {
      label: '风险等级',
      sortable: true,
      editDisplay: false,
      row: true,
      width: 100,
      prop: 'riskLevel',
    },
    {
      label: '',
      editDisplay: false,
      prop: 'tlan',
      row: true,
      hide: true,
    },
    {
      label: '来源ID',
      // labelWidth: 100,
      // width: 310,
      width: 230,
      prop: 'sourceId',
      slot: true,
      row: true,
      editDisabled: true,
      span: 24,
    },
  ],
};
